import React, { useState } from "react";
import "../styles/Contact.css";
import SecretaryImg from "../assets/secretary.jpg";
import {
  FaTelegramPlane,
  FaInstagram,
  FaWhatsapp,
  FaFacebookF,
} from "react-icons/fa";
import { SiTiktok } from "react-icons/si";

const Contact = () => {
  const [formData, setFormData] = useState({
    user_name: "",
    user_email: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const subject = encodeURIComponent(
      `New Inquiry from ${formData.user_name}`
    );

    const body = encodeURIComponent(`Name: ${formData.user_name}

Email: ${formData.user_email}

Message:
${formData.message}`);

    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=daniimportandexport0@gmail.com&su=${subject}&body=${body}`;

    window.open(gmailUrl, "_blank");

    setSubmitted(true);

    setFormData({
      user_name: "",
      user_email: "",
      message: "",
    });

    setTimeout(() => {
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-image">
          <img src={SecretaryImg} alt="Secretary at computer" />
        </div>

        <div className="contact-form-section">
          <h1>Contact Us</h1>
          <p>
            Get in touch with us for trade inquiries, product sourcing, or
            partnership opportunities.
          </p>

          <form className="contact-form" onSubmit={sendEmail}>
            <input
              type="text"
              placeholder="Your Name"
              name="user_name"
              value={formData.user_name}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              placeholder="Your Email"
              name="user_email"
              value={formData.user_email}
              onChange={handleChange}
              required
            />

            <textarea
              placeholder="Your Message"
              name="message"
              rows={5}
              value={formData.message}
              onChange={handleChange}
              required
            />

            <button type="submit">Send Message</button>

            {submitted && (
              <p className="contact-success">
                Gmail has been opened with your message ready to send.
              </p>
            )}
          </form>

          <div className="social-icons">
            <a
              href="https://t.me/Daniy3l"
              target="_blank"
              rel="noreferrer"
              className="telegram"
              aria-label="Telegram"
            >
              <FaTelegramPlane />
            </a>

            <a
              href="https://www.instagram.com/daninchina?igsh=MW9nanIzNGlkd3FsOA=="
              target="_blank"
              rel="noreferrer"
              className="instagram"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.tiktok.com/@daniimportexport?_r=1&_t=ZM-91y8PKNVxTE"
              target="_blank"
              rel="noreferrer"
              className="tiktok"
              aria-label="TikTok"
            >
              <SiTiktok />
            </a>

            <a
              href="https://web.facebook.com/Daniinchina1?__tn__=-UC"
              target="_blank"
              rel="noreferrer"
              className="facebook"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>

            <a
              href="https://wa.me/message/X6KLKUUKNBGJE1"
              target="_blank"
              rel="noreferrer"
              className="whatsapp"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;